<template>
  <div>
    <ScrollupSection />
    <div class="all-area">
      <HeaderSection />
      <BreadcrumbSection />
      <PricingSection />
      <NewsletterSection />
      <FooterSection />
    </div>
  </div>
</template>

<script>
import ScrollupSection from '../../Scrollup/Scrollup'
import HeaderSection from '../../Header/HeaderOne'
import BreadcrumbSection from '../../Breadcrumb/Pricing/Pricing'
import PricingSection from '../../Pricing/Pricing'
import NewsletterSection from '../../Newsletter/Newsletter'
import FooterSection from '../../Footer/Footer'

export default {
  name: 'Pricing',
  components: {
    ScrollupSection,
    HeaderSection,
    BreadcrumbSection,
    PricingSection,
    NewsletterSection,
    FooterSection
  }
}
</script>

<style>

</style>
